import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { Button, Table, Tag } from "antd"

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DownloadIcon from '@mui/icons-material/Download';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import TabletAndroidOutlinedIcon from '@mui/icons-material/TabletAndroidOutlined';

// Constants

// Components
// import PlayedVideo from "./components/PlayedVideo";
// import TimelineSlider from "./components/TimelineSlider";
// import CameraBox from "../../components/Map/components/LiveCameraPopup/components/CameraBox";
import { EmptyIndicator } from "../../components/Indicator";
import { PrimaryButton } from "../../components/Decoration/Button";

// handlers
import { table_handler, address_handler, hookHDLR } from "../../handlers";
// Service Library
import { REDUX, TIME } from "../../services/util";
// import NoVideoBox from "./components/NoVideoBox";
import Cameras from "./components/Cameras";
// import VideoBox from "./components/VideoBox";

const {
    reduxStoreWrapper
} = REDUX

const {
    getColumnSearchProps
} = table_handler

const {
    getAddressHDLR,
} = address_handler

const {
    arraysHaveSameData,
    usePrevious
} = hookHDLR

const VideoPlaybackManagement = () => {

    const videoPlayback = useSelector(reduxStoreWrapper("devicesMDVR.playbackByTime"))
    const coordinates = useSelector(reduxStoreWrapper("locationTracking.byCoordinates"))
    const loading = useSelector(reduxStoreWrapper('style.loading.routePlayback'))

    const searchTextState = useState('')
    const searchedColumnState = useState('')

    const [ url, setUrl ] = useState(null)

    const dataSource = React.useMemo(() => {
        return Object.values(videoPlayback)
        .map(vp => {

            return {
                // key: vp.filename,
                // fileid: vp.fileid,
                // source: vp.source,
                // vid: vp.vid,
                // downloadLink: vp.downloadLink?.replace('http', 'https'),
                // playbackLink: vp.playbackLink?.replace('http', 'https'),
                // channel: 'CH' + vp.filenameParseResult.channel,
                // time: vp.filenameParseResult.timestampDate,
                // timeEpoch: vp.time,
                // recordType: vp.filenameParseResult.recordingType === 'Normal' ? 'Normal' : 'Alarm',
                // eventName: vp.eventName || '-',
                // lat: vp.lat,
                // lon: vp.lon,
                ...vp,
                duration: TIME.parseDuration(vp.durationMs),
                address: coordinates[`${vp.lat},${vp.lon}`]
            }
        }).sort((a, b) => b.time - a.time)

    }, [videoPlayback])

    const channelMap = [ ...new Set(dataSource.map(ds => ds.cameraName || ds.channel)) ]

    const columns = [
        {
            title: "Date",
            fixed: 'left',
            sorter: (a, b) => a.time - b.time,
            render: data => data.time
        },
        {
            title: "Camera",
            // dataIndex: "cameraName",
            filters: channelMap.map(c => ({
                text: c,
                value: c
            })),
            onFilter: (value, record) => (record.cameraName || record.cameraName) === value,
            render: data => `${data.cameraName ? data.cameraName : data.channel}`
        },
        {
            title: "Recording Type",
            dataIndex: 'recordType',
            filters: ['Alarm', 'Normal'].map(rt => ({
                text: rt,
                value: rt
            })),
            onFilter: (value, record) => record.recordType === value,
            render: (data) => {
                const color = data === 'Alarm' ? 'red' : 'blue'

                return (
                    <Tag color={color}>{data}</Tag>
                )
            }
            },
        {
            title: "Event Name",
            dataIndex: 'eventName',
             ...getColumnSearchProps("Event Name", 'eventName', searchTextState, searchedColumnState),
        },
                    {
            title: "Duration",
            dataIndex: "duration",
             sorter: (a, b) => a.duration - b.duration,
            // ...getColumnSearchProps("Duration", 'duration', searchTextState, searchedColumnState),
        },
            {
            title: "Source",
            dataIndex: "source",
            ...getColumnSearchProps("Source", 'source', searchTextState, searchedColumnState),
            render: (data) => <Button icon={data === 'server' ? <DnsOutlinedIcon /> : <TabletAndroidOutlinedIcon />}>{data}</Button>
        },
        {
            title: "Location",
            width: 250,
            // dataIndex: "location",
            ...getColumnSearchProps("Location", 'address', searchTextState, searchedColumnState),
            render: (data) => data.address || (data.lat && `${data.lat}, ${data.lon}` || '-') 
            },
        {
            title: "Actions",
            fixed: 'right',
            render: (data) => {
                return (
                    <div style={{ display: 'flex', gap: '.5em' }}>
                        <PrimaryButton icon={<PlayArrowIcon color="#fff"/>} onClick={() => {
                            setTimeout(() => setUrl(data.playbackLink), 1000)
                        }} />
                        <Button icon={<DownloadIcon />} onClick={() => window.open(data.downloadLink, "_blank")}/>
                    </div>
                )
            }
        }
    ];

    getAddressHDLR(dataSource.map(d => ({ vid: d.vid, lat: d.lat, lon: d.lon })))

    const preData = usePrevious(dataSource)
    const isSame = arraysHaveSameData(preData, dataSource, 'time')

    useEffect(() => {
       setUrl(null)
    }, [!isSame])

    return (
        <div style={{ padding: '1em' }}>
            {
                dataSource.length
                &&
                <div>
                    {/* {
                        url
                        &&
                        <CameraBox url={url} controls={true} isLive={true} />
                        // <VideoBox url={url} />
                        ||
                        <NoVideoBox />
                    } */}
                    <Cameras url={url} />
                    <Table 
                        loading={loading}
                        style={{ marginTop: '1.5em' }}
                        dataSource={dataSource} 
                        columns={columns} 
                        pagination={{ position: ['bottomRight'] }}
                        scroll={{
                            y: '50vh',
                            x: columns && columns.length * 200
                        }}
                    />
                </div>
                || 
                <EmptyIndicator  />
            }
        </div>
    )
}


export default React.memo(VideoPlaybackManagement)